<template>
  <div class="pc-search">
    <h1 style="margin-bottom:20px">Organization</h1>
    <el-form :model="keywordData" :inline="true">
      <el-form-item label="名称" class="title">
        <el-input v-model="keywordData.name_keyword"></el-input>
      </el-form-item>
      <el-form-item label="地址" class="keyword">
<el-input v-model="keywordData.address_keyword"></el-input>
      </el-form-item>
      <el-form-item label="状态" clearable placeholder="状态" class="status">
        <el-select v-model="keywordData.status" clearable placeholder="状态">
          <el-option label="有效" value="1"></el-option>
          <el-option label="无效" value="0"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <button class="pc-search-btn" @click="search">筛选</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keywordData: {
        id: null,
        name_keyword: "",
        address_keyword: "",
        status: null,
      },
    };
  },
  mounted() {
  },
  methods: {
    search() {
      console.log(this.keywordData);
      this.$emit("search", this.keywordData);
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-search {
  @include table-search;
    .pc-search-btn{
    margin-left: 90%;
  }
  .college {
    width: 300px;
  }
  .title {
    width: 370px;
  }
  .is-wupen {
    width: 200px;
    margin-right: 110px;
  }
  .tag {
    width: 300px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
  .status {
    width: 200px;
  }
  .keyword {
    width: 370px;
    height: 40px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/exhibition/component/OrganizationSearch.vue